import { Dimensions } from './Dimensions';

export function getDimensionsConstrainedToContainerWidth(
    elementDimensions: Dimensions,
    containerDimensions: Dimensions
) {
    const newDimensions = {
        width: containerDimensions.width,
        height: Math.floor(
            (containerDimensions.width / elementDimensions.width) * elementDimensions.height
        ),
    };

    return containerDimensions.width > elementDimensions.width ? elementDimensions : newDimensions;
}

export default getDimensionsConstrainedToContainerWidth;
